export const TELEGRAM_IOS_APP_URL = 'https://apps.apple.com/us/app/telegram-messenger/id686449807'
export const TELEGRAM_ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=org.telegram.messenger'
export const TELEGRAM_APPS = 'https://telegram.org/apps'